import {getDataView} from "./getDataView";

export function getDataViewLifecycle(ctx: any) {
  return getDataView(ctx).lifecycle;
}
